import { useTheme } from "@mui/styles";
import React from "react";

const SubTitle = ({ children, styles = {} }) => {
  const theme = useTheme();
  return (
    <div
      style={{
        fontFamily: "noto-sans",
        fontSize: "0.8rem",
        color: theme.COLORS.WHITE.backgroundWhite,
        fontWeight: "bold",
        marginBottom: "1rem",
        ...styles,
      }}
    >
      {children}
    </div>
  );
};

export default SubTitle;
